import { render } from "./cabinet.vue?vue&type=template&id=6a02335c&scoped=true"
import script from "./cabinet.vue?vue&type=script&lang=js"
export * from "./cabinet.vue?vue&type=script&lang=js"

import "./cabinet.vue?vue&type=style&index=0&id=6a02335c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a02335c"]])

export default __exports__